import { useState } from "react";
import { Input, Form, Modal, Typography, Switch } from "antd";

import { createItem, updateItem } from "@/api/unitTypes";

const { Text } = Typography;

// Окно для создания/редактирования типа РГ, содержит форму
const UnitTypeModal = ({ data = {}, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      if (data.uuid) {
        await updateItem({ ...data, ...values });
      } else {
        await createItem(values);
      }

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title={
        data.uuid
          ? "Редактирование типа рабочей группы"
          : "Добавление нового типа рабочей группы"
      }
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText={data.uuid ? "Сохранить" : "Добавить"}
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        <Form.Item
          name="name"
          label="Название"
          rules={[{ required: true, message: "Пожалуйста, введите название" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="is_hierarchical"
          label="Участвует в оргструктуре"
          valuePropName="checked"
          layout="horizontal"
        >
          <Switch
            disabled={data?.uuid ? !data?.can_change_hierarchical : false}
          />
        </Form.Item>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default UnitTypeModal;
